export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  ShouldSupportTimeSlotsInCheckout: 'specs.stores.ShouldSupportTimeSlotsInCheckout',
  Fix3DSInExpressMethods: 'specs.stores.Fix3DSInExpressMethods',
  AddLocaleAsAControllerParam: 'specs.stores.AddLocaleAsAControllerParam',
  NoFastFlowRedirectOnShippingInfoCollected: 'specs.stores.NoFastFlowRedirectOnShippingInfoCollected'
};
//# sourceMappingURL=SPECS.js.map